<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{cargoIcon}}</v-icon>
          Cargo
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top v-if="!query">
          <v-btn flat slot="activator" @click="doSave()" :loading="quotation.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Quotation/Proposal</span>
        </v-tooltip>
        <!-- v-tooltip top v-if="query">
          <v-btn flat slot="activator" @click="printQuote">
            Print Quote
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
          <span>Print Quotation</span>
        </v-tooltip -->
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptNTU = true">
                <v-list-tile-title>Not Taken Up</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptRevert = true" v-if="checkAccess(['cargoQuoteRevertNQ'])">
                <v-list-tile-title>Revert to New Quotation</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">Quotation No.</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span class="title">{{commonForm.proposalNo}}</span>
            </v-flex>
            <template v-if="commonInfo.premium.billPremiumPayable">
              <v-flex xs4>
                <v-subheader class="queryLabel">Premium Payable</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{commonForm.billCurr}} {{formatDisplayNumber(commonInfo.premium.billPremiumPayable, 2)}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siDeclared">
              <v-flex xs4>
                <v-subheader class="queryLabel">Declared Sum Insured</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{cargoForm.siCurr}} {{formatDisplayNumber(cargoForm.siDeclared, 2)}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siBalance">
              <v-flex xs4>
                <v-subheader class="queryLabel">Balance Sum Insured</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{cargoForm.siCurr}} {{formatDisplayNumber(cargoForm.siBalance)}}</span>
              </v-flex>
            </template>
            <v-flex xs4>
              <v-subheader class="queryLabel">Current Status</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span :class="currentStatusClass">{{currentStatusLabel}}</span>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">Intermediary</v-subheader>
            </v-flex>
            <v-flex xs8>
              <span>{{commonForm.intermediary}} - {{queryInfo.intermediary}}</span>
            </v-flex>
            <v-flex xs4>
              <v-subheader class="queryLabel">Quotation Type</v-subheader>
            </v-flex>
            <v-flex xs8>
              <div>{{quotationType(commonForm.quotationType)}}</div>
            </v-flex>
            <template v-if="commonForm.masterProposalNo">
              <v-flex xs4>
                <v-subheader class="queryLabel">Contract/Master Proposal No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div>{{commonForm.masterProposalNo}}</div>
              </v-flex>
            </template>
            <template v-if="commonForm.product">
              <v-flex xs4>
                <v-subheader class="queryLabel">Product</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.product}} - {{queryInfo.product}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.busCls">
              <v-flex xs4>
                <v-subheader class="queryLabel">Business Class</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{cargoForm.busCls}} - {{queryInfo.busCls}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.acceptDate">
              <v-flex xs4>
                <v-subheader class="queryLabel">Acceptance Date</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDate(commonForm.acceptDate)}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siCurr">
              <v-flex xs4>
                <v-subheader class="queryLabel">Sum Insured Currency</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{cargoForm.siCurr}} - {{formatDisplayNumber(cargoForm.siCurrRate, 7)}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.billCurr">
              <v-flex xs4>
                <v-subheader class="queryLabel">Billing Currency</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.billCurr}} - {{formatDisplayNumber(commonForm.billCurrRate, 7)}}</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.siUplift">
              <v-flex xs4>
                <v-subheader class="queryLabel">SI Uplift</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDisplayNumber(cargoForm.siUplift)}}%</span>
              </v-flex>
            </template>
            <template v-if="cargoForm.tolerance">
              <v-flex xs4>
                <v-subheader class="queryLabel">Tolerance</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{formatDisplayNumber(cargoForm.tolerance)}}%</span>
              </v-flex>
            </template>
            <template v-if="commonForm.campaign">
              <v-flex xs4>
                <v-subheader class="queryLabel">Campaign</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.campaign}} - {{queryInfo.campaign}}</span>
              </v-flex>
            </template>
            <template v-if="commonForm.promotion">
              <v-flex xs4>
                <v-subheader class="queryLabel">Promotion</v-subheader>
              </v-flex>
              <v-flex xs7>
                <span>{{commonForm.promotion}} - {{queryInfo.promotion}}</span>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <confirm v-model="promptNTU" @ok="doNTU">
      Confirm that you want to change the status of this Quotation to
      <b>Not Taken Up</b>?
    </confirm>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Quotation to
      <b>Void</b>?
    </confirm>
    <confirm v-model="promptRevert" @ok="doRevert">
      Confirm that you want to revert the status of this Quotation to
      <b>New Quotation</b>?
    </confirm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'
import { quotationType } from '@/const/underwriting/cargo'
import { AGENCY_QUOTATION_LEAVEQUOTE } from '@/store/types'

export default {
  data() {
    return {
      promptNTU: false,
      promptVoid: false,
      promptRevert: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    currentStatusClass() {
      if (this.quotation.commonInfo.statusCode === 'QD' || this.quotation.commonInfo.statusCode === 'PD' || this.quotation.commonInfo.statusCode === 'VO' || this.quotation.commonInfo.statusCode === 'NTU' || this.quotation.commonInfo.statusCode === 'CL') {
        return 'error--text'
      } else if (this.quotation.commonInfo.statusCode === 'QPA' || this.quotation.commonInfo.statusCode === 'PPA') {
        return 'warning--text'
      } else if (this.quotation.commonInfo.statusCode === 'IF' || this.quotation.commonInfo.statusCode === 'PO') {
        return 'success--text'
      } else {
        return ''
      }
    },
    cargoForm() {
      return this.quotation.cargoForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    queryInfo() {
      return this.quotation.queryInfo
    },
    cargoIcon() {
      return appIcon.CARGO
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote')
    },
    printQuote() {
      this.$snotify.warning('Feature Coming Soon!')
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    quotationType(value) {
      return quotationType[value]
    },
    doNTU() {
      this.$root.$emit('ntu')
    },
    async doVoid() {
      this.$root.$emit('void')
    },
    async doRevert() {
      try {
        await this.$store.dispatch('revertCrgoQuote')

        this.$snotify.success('Quotation reverted to New Quotation')
        this.$store.commit(AGENCY_QUOTATION_LEAVEQUOTE)
        this.$router.push({ name: 'cargoQuote' })
      } catch (err) {
        this.notify(err)
      }
    }
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}

.permitStatus {
  padding-left: 20px;
}
</style>
